var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19569"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 6401"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 14643"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 9.805v8.069a3.76 3.76 0 0 0 3.763 3.762h12.289a3.76 3.76 0 0 0 3.762-3.762V9.805a3.76 3.76 0 0 0-1.7-3.144l-6.14-4.042a3.76 3.76 0 0 0-4.133 0L3.696 6.657A3.77 3.77 0 0 0 2 9.805",
  "data-name": "Path 16662"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.907 17.26v-3.814",
  "data-name": "Line 1214"
})))));
export { SvgHome as ReactComponent };
export default __webpack_public_path__ + "static/media/home.f8efb1faf0e0686b93eaf8676d22b3fe.svg";